// extracted by mini-css-extract-plugin
export var text = "_3k-0";